import {
  Bar,
  YAxis,
  XAxis,
  CartesianGrid,
  ResponsiveContainer,
  BarChart as ReBarChart,
} from "recharts";
import { useSelector } from "react-redux";

import { currencyFormatter } from "../../services";

export const PortfolioBarChart = ({ chartData, bars, height, barSize }) => {
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const tickFormatter = (value, unit) => {
    if (unit === currencySymbol) {
      return currencyFormatter(value, currencySymbol);
    }

    return `${value}%`;
  };

  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReBarChart data={chartData.data} barSize={barSize || 15}>
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        <YAxis
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => tickFormatter(value, chartData.unit)}
          tickCount="4"
        />
        <XAxis
          tickLine={false}
          dataKey="name"
          padding={{ left: 25, right: `${chartData.data.length === 1 ? 150 : 25}` }}
        />
        {bars.map((bar, i) => (
          <Bar key={i} dataKey={bar.dataKey} fill={bar.fill} />
        ))}
      </ReBarChart>
    </ResponsiveContainer>
  );
};
